import React from "react";
import { FiMapPin, FiUsers } from "react-icons/fi";

const COMING_SOON_MESSAGE =
  "หากต้องการใช้ห้องประชุมฝั่ง TV Thunder ให้ติดต่อพี่ละอองดาว ผ่าน LINE";

const RoomCards = ({ rooms, selectedRoomId, onSelectRoom }) => {
  const sortedRooms = (rooms || []).slice().sort((a, b) => {
    const aComingSoon = a?.isComingSoon ? 1 : 0;
    const bComingSoon = b?.isComingSoon ? 1 : 0;
    if (aComingSoon !== bComingSoon) return aComingSoon - bComingSoon;
    return (a?.sortOrder || 0) - (b?.sortOrder || 0);
  });

  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
      {sortedRooms.map((room) => {
        const roomId = room?._id || room?.id;
        const active = roomId === selectedRoomId;
        const isComingSoon = !!room?.isComingSoon;

        return (
          <button
            key={roomId}
            type="button"
            disabled={isComingSoon}
            onClick={() => {
              if (!isComingSoon) onSelectRoom(roomId);
            }}
            className={[
              "group w-full text-left rounded-2xl border p-4 transition-all",
              "bg-white dark:bg-slate-900",
              isComingSoon
                ? "cursor-not-allowed border-gray-200 opacity-75 dark:border-slate-800"
                : active
                ? "border-indigo-500 ring-2 ring-indigo-200 dark:ring-indigo-400/30"
                : "border-gray-200 hover:border-indigo-300 dark:border-slate-800 dark:hover:border-indigo-400/60",
            ].join(" ")}
          >
            <div className="flex items-start justify-between gap-3">
              <div>
                <div className="text-sm font-semibold text-gray-800 dark:text-slate-100">
                  {room.name}
                </div>

                <div className="mt-1 flex items-center gap-2 text-xs text-gray-500 dark:text-slate-400 flex-wrap">
                  <span className="inline-flex items-center gap-1">
                    <FiMapPin className="text-gray-400 dark:text-slate-400" />
                    ชั้น {room.floor}
                  </span>

                  <span className="text-gray-300 dark:text-slate-600">•</span>

                  <span className="inline-flex items-center gap-1">
                    <FiUsers className="text-gray-400 dark:text-slate-400" />
                    รองรับ {room.capacityLabel || room.capacity} คน
                  </span>
                </div>

                {isComingSoon && (
                  <p className="mt-3 text-xs font-semibold text-red-600 dark:text-red-400">
                    {room.comingSoonMessage || COMING_SOON_MESSAGE}
                  </p>
                )}

              </div>

              <span
                className={[
                  "shrink-0 text-[11px] px-2 py-1 rounded-full border",
                  isComingSoon
                    ? "border-red-200 bg-red-50 text-red-600 dark:border-red-400/40 dark:bg-red-500/10 dark:text-red-300"
                    : active
                    ? "border-indigo-500 text-indigo-700 bg-indigo-50 dark:bg-indigo-500/15 dark:text-indigo-300 dark:border-indigo-400"
                    : "border-gray-200 text-gray-500 bg-gray-50 dark:bg-slate-800 dark:text-slate-400 dark:border-slate-700",
                ].join(" ")}
              >
                {isComingSoon ? "Coming soon" : active ? "Selected" : "Select"}
              </span>
            </div>
          </button>
        );
      })}
    </div>
  );
};

export default RoomCards;
